// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.email-Input {
  margin-right: 1em;
  width: 17em;
}

.email-Input-searchBtn {
  margin-right: 15px;
  display: inline-block;
}
.dropdown {
  margin-left: 10px; /* Adjust the value as needed */
  width: 150px; /* Set a specific width */
}
.container2 {
  background-color: #F1F1F1;
  border: solid 1px #d4d4d4;
  margin-bottom: 10px;
  padding-top: 20px;
}
.table th, .table td {
  white-space: nowrap;
  vertical-align: middle; /* Ensure vertical alignment */
  padding: 0; /* Remove padding to eliminate space */
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.table-bordered {
  border: 1px solid #ddd;
}
.applookup-textbox {
  width: 100%; /* Adjust the width to fit the column */
  box-sizing: border-box; /* Include padding and border in the element's total width and height */
}
.table-bordered th, .table-bordered td {
  border: 1px solid #ddd;
  padding: 0; /* Remove padding to eliminate space */
}
.title h3 {
  color: white !important;
  text-align: left;
  margin-top: auto;
  margin-bottom: auto;
  }

.search-button {
  background-color: #286090;
  color: white;
  padding: 3px 15px;
  cursor: pointer;
  margin-left: 10px;
}

.addBtn {
  margin-top: 15px;
}
.title {
  background-color: #6699cc;
  color: #ffffff;
  padding: 10px;
  text-align: center;
  font-size: 100%;
}
.button-group {
  display: flex;
  justify-content: center;
  gap: 30px;
}

.row.grayBackground {
  margin-top: 15px;
  background-color: #F1F1F1;
  margin-bottom: 15px;
}

.center-content {
  margin: auto !important;
  text-align: center;
}

.form-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.form-group {
  flex: 1;
  margin-right: 20px;
}
strong {
  font-family: "GothamBold", Arial, sans-serif!important;
  font-weight: normal!important;
}
.content{
  font-family:"GothamNarrowBook",Arial,sans-serif ;
}
.file-container {
  border: 2px solid #0B2D71;
  width: 100%;
  margin: 20px auto;
  background-color: #fff; 
}
.select-text {
  color: white;
  padding: 5px;
  background-color: #0B2D71;
  text-align: left;
  font-family: "GothamBold",Arial,sans-serif;
}
.text-padding
{
  padding-left: 2%;
  padding-right: 2%;
  padding-bottom: 1%;
}
.input-small {
  width: 200px; /* Adjust the width as needed */
}
table {
  border-collapse: collapse;
}
.table th, .table td {
  white-space: nowrap;
}
.checkbox-container {
  display: flex;
  align-items: center;
}

.container {
  display: flex;
  align-items: center;
}
.container table {
  margin-right: 10px; /* Adjust the margin as needed */
}

.form-control {
  width: auto;
  display: inline-block;
}
.textbox{
  width: 250px;
  height: 35px;
}
.emailtextbox{
  width: 250px;
  height: 35px;
}
.grid-buttons{
  display: flex;
   gap: 10px;
}
.mandatory{
  color: red;
  /* font-weight: bold; */
}
.inline-input {
  display: inline-block;
  margin-left: 10px; /* Adjust the spacing as needed */
}
 
.radio-label {
  display: inline-flex;
  align-items: center;
  margin-right: 15px; /* Adjust the spacing between radio buttons as needed */
}
table th {
  background-color: #0b2d71 !important;
  color: white;
  font-weight: bold;
}
th, td {
  border: 1px solid white;
  text-align: center;
  padding: 8px;
}
.upperCaseText {
  text-transform: uppercase;
}

.btn {
  margin: 5px;
}
.date-in-range {
  background-color: red;
  
}
  .warning-message {
  color: red;
  font-weight: bold;
}
button:disabled {
  background-color: grey;
  color: white; /* Optional: Change text color */
  cursor: not-allowed;
  opacity: 0.6; /* Optional: Adjust opacity */
}
.date-duplicate {
  background-color: lightblue; /* Blue for grid duplicates */
}

.shift{
  margin-left: 2%;
}
.large-lookup {
  flex-grow: 1;
}
.lookup-row {
  display: flex;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/temporaryredelegation/enterredelegation/enterredelegation.component.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,iBAAiB,EAAE,+BAA+B;EAClD,YAAY,EAAE,yBAAyB;AACzC;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,sBAAsB,EAAE,8BAA8B;EACtD,UAAU,EAAE,sCAAsC;AACpD;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW,EAAE,uCAAuC;EACpD,sBAAsB,EAAE,uEAAuE;AACjG;AACA;EACE,sBAAsB;EACtB,UAAU,EAAE,sCAAsC;AACpD;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB;;AAEF;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,OAAO;EACP,kBAAkB;AACpB;AACA;EACE,sDAAsD;EACtD,6BAA6B;AAC/B;AACA;EACE,gDAAgD;AAClD;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,0CAA0C;AAC5C;AACA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,YAAY,EAAE,+BAA+B;AAC/C;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB,EAAE,gCAAgC;AACtD;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,aAAa;GACZ,SAAS;AACZ;AACA;EACE,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,iBAAiB,EAAE,iCAAiC;AACtD;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB,EAAE,uDAAuD;AAC7E;AACA;EACE,oCAAoC;EACpC,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;;AAEvB;EACE;EACA,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,YAAY,EAAE,gCAAgC;EAC9C,mBAAmB;EACnB,YAAY,EAAE,6BAA6B;AAC7C;AACA;EACE,2BAA2B,EAAE,6BAA6B;AAC5D;;AAEA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;AACrB","sourcesContent":[".email-Input {\n  margin-right: 1em;\n  width: 17em;\n}\n\n.email-Input-searchBtn {\n  margin-right: 15px;\n  display: inline-block;\n}\n.dropdown {\n  margin-left: 10px; /* Adjust the value as needed */\n  width: 150px; /* Set a specific width */\n}\n.container2 {\n  background-color: #F1F1F1;\n  border: solid 1px #d4d4d4;\n  margin-bottom: 10px;\n  padding-top: 20px;\n}\n.table th, .table td {\n  white-space: nowrap;\n  vertical-align: middle; /* Ensure vertical alignment */\n  padding: 0; /* Remove padding to eliminate space */\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.table-bordered {\n  border: 1px solid #ddd;\n}\n.applookup-textbox {\n  width: 100%; /* Adjust the width to fit the column */\n  box-sizing: border-box; /* Include padding and border in the element's total width and height */\n}\n.table-bordered th, .table-bordered td {\n  border: 1px solid #ddd;\n  padding: 0; /* Remove padding to eliminate space */\n}\n.title h3 {\n  color: white !important;\n  text-align: left;\n  margin-top: auto;\n  margin-bottom: auto;\n  }\n\n.search-button {\n  background-color: #286090;\n  color: white;\n  padding: 3px 15px;\n  cursor: pointer;\n  margin-left: 10px;\n}\n\n.addBtn {\n  margin-top: 15px;\n}\n.title {\n  background-color: #6699cc;\n  color: #ffffff;\n  padding: 10px;\n  text-align: center;\n  font-size: 100%;\n}\n.button-group {\n  display: flex;\n  justify-content: center;\n  gap: 30px;\n}\n\n.row.grayBackground {\n  margin-top: 15px;\n  background-color: #F1F1F1;\n  margin-bottom: 15px;\n}\n\n.center-content {\n  margin: auto !important;\n  text-align: center;\n}\n\n.form-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.form-group {\n  flex: 1;\n  margin-right: 20px;\n}\nstrong {\n  font-family: \"GothamBold\", Arial, sans-serif!important;\n  font-weight: normal!important;\n}\n.content{\n  font-family:\"GothamNarrowBook\",Arial,sans-serif ;\n}\n.file-container {\n  border: 2px solid #0B2D71;\n  width: 100%;\n  margin: 20px auto;\n  background-color: #fff; \n}\n.select-text {\n  color: white;\n  padding: 5px;\n  background-color: #0B2D71;\n  text-align: left;\n  font-family: \"GothamBold\",Arial,sans-serif;\n}\n.text-padding\n{\n  padding-left: 2%;\n  padding-right: 2%;\n  padding-bottom: 1%;\n}\n.input-small {\n  width: 200px; /* Adjust the width as needed */\n}\ntable {\n  border-collapse: collapse;\n}\n.table th, .table td {\n  white-space: nowrap;\n}\n.checkbox-container {\n  display: flex;\n  align-items: center;\n}\n\n.container {\n  display: flex;\n  align-items: center;\n}\n.container table {\n  margin-right: 10px; /* Adjust the margin as needed */\n}\n\n.form-control {\n  width: auto;\n  display: inline-block;\n}\n.textbox{\n  width: 250px;\n  height: 35px;\n}\n.emailtextbox{\n  width: 250px;\n  height: 35px;\n}\n.grid-buttons{\n  display: flex;\n   gap: 10px;\n}\n.mandatory{\n  color: red;\n  /* font-weight: bold; */\n}\n.inline-input {\n  display: inline-block;\n  margin-left: 10px; /* Adjust the spacing as needed */\n}\n \n.radio-label {\n  display: inline-flex;\n  align-items: center;\n  margin-right: 15px; /* Adjust the spacing between radio buttons as needed */\n}\ntable th {\n  background-color: #0b2d71 !important;\n  color: white;\n  font-weight: bold;\n}\nth, td {\n  border: 1px solid white;\n  text-align: center;\n  padding: 8px;\n}\n.upperCaseText {\n  text-transform: uppercase;\n}\n\n.btn {\n  margin: 5px;\n}\n.date-in-range {\n  background-color: red;\n  \n}\n  .warning-message {\n  color: red;\n  font-weight: bold;\n}\nbutton:disabled {\n  background-color: grey;\n  color: white; /* Optional: Change text color */\n  cursor: not-allowed;\n  opacity: 0.6; /* Optional: Adjust opacity */\n}\n.date-duplicate {\n  background-color: lightblue; /* Blue for grid duplicates */\n}\n\n.shift{\n  margin-left: 2%;\n}\n.large-lookup {\n  flex-grow: 1;\n}\n.lookup-row {\n  display: flex;\n  align-items: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
